export default __webpack_public_path__ + "static/media/PederHanssen-min.b7fc3b1d.jpg";